import React, { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { useAuthenticatedAdmin } from '../providers/AuthenticatedAdminProvider';

export const UnauthenticatedAdminPage = () => {
  const navigate = useNavigate();

  const { authenticatedAdmin } = useAuthenticatedAdmin();

  useEffect(() => {
    if (authenticatedAdmin) {
      enqueueSnackbar('You are already logged in', { variant: 'error' });
      navigate('/admin');
    }
  }, [authenticatedAdmin, navigate]);

  if (authenticatedAdmin) {
    return null;
  }

  return <Outlet />;
};

export default UnauthenticatedAdminPage;
